module.exports = __webpack_public_path__ + "static/media/july_2025_1.5859a9dd.webp";